import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { COMMON_IMPORTS } from '../../../global-misc/common-imports';
import { GlobalConsentFormComponent, ConsentData } from '../../../global-components/global-consent-form/global-consent-form.component';

@Component({
    selector: 'app-consent-dialog',
    imports: [...COMMON_IMPORTS, DialogModule, GlobalConsentFormComponent],
    templateUrl: './consent-dialog.component.html'
})
export class ConsentDialogComponent {
  @Output() consentDialogResult = new EventEmitter<ConsentData>();
  @ViewChild(GlobalConsentFormComponent) consentForm!: GlobalConsentFormComponent;

  dialogVisible = true;

  public accepted = false;

  public constructor() { }

  onConfirm() {
    const formGroup:FormGroup = this.consentForm.formGroup;

    if (formGroup.invalid) {
      formGroup.setErrors({
        custom: "You must consent to data collection in order to sign up."
      });
      return;
    }

    this.accepted = true;
    this.consentDialogResult.emit( this.consentForm.getConsentData() );

    this.dialogVisible = false;
    formGroup.markAllAsTouched();
  }

  onCancel() {
    this.accepted = false;
    this.consentDialogResult.emit( this.consentForm.getConsentData() );
    this.dialogVisible = false;
  }
}
